@if (items?.length || title || navigateBackLink) {
  <div class="d-flex flex-stack flex-row-fluid">
    <div class="gap-4 me-3">
      @if (items?.length) {
        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7">
          <li class="breadcrumb-item cursor-pointer" routerLink="/">
            <bws-mdi name="home-city-outline" class="text-gray-700"/>
          </li>
          @for (itm of items; track itm; let last = $last) {
            <li class="breadcrumb-item fw-bold" [ngClass]="last ? 'text-gray-500' : 'text-gray-600'">
              @if (itm.routerLink) {
                <a [routerLink]="itm.routerLink">
                  {{itm.title}}
                </a>
              }
              @if (!itm.routerLink) {
                {{itm.title}}
              }
            </li>
            @if (!last) {
              <li class="breadcrumb-item">
                <bws-mdi name="chevron-right" class="text-gray-700 mx-n1"/>
              </li>
            }
          }
        </ul>
      }
      @if (title || navigateBackLink) {
        <!-- Not an <h1>: this is the navigation label in the header bar, rendered on every
             page alongside the page's real heading. As an <h1> it gave every route two
             competing top-level headings (often the same word twice, e.g. "Funktionen").
             .fs-2 carries the visual size, so this is a purely semantic change. -->
        <div class="h1 text-gray-900 m-0 fs-2">
          @if (navigateBackLink) {
            <button type="button" class="btn btn-active-color-primary btn-color-gray-800 btn-icon btn-sm"
              [routerLink]="navigateBackLink">
              <bws-mdi name="arrow-left" class="fs-1"/>
            </button>
          }
          {{title}}
        </div>
      }
    </div>
  </div>
}
